var Conviva = require('./conviva');

module.exports = { Conviva: Conviva };
